import { useState } from "react"

let id = 0
const getId = () => {
    id++
    return `i${id.toString(16)}`
}

export function useHtmlId() {
    const [id] = useState(getId)
    return id
}
